export default __webpack_public_path__ + "static/media/obfuspower.54798908.png";